import React, { FC, useContext, useMemo } from 'react';
import { PageHeader } from '../components/PageHeader/PageHeader';
import { useTranslation } from 'react-i18next';
import { UserContextFromCurrentUserProvider } from '../contexts/UserContextProvider';
import { UserLicensesFetcher } from '../fetchers/UserLicensesFetcher';
import { LicensesContextFromUserLicenses } from '../contexts/LicensesContextProviders';
import { LicensesTable } from '../components/LicensesTable/LicensesTable';
import { RequestAirgapButton } from '../components/Licenses/RequestAirgapButton';
import Grid from '@mui/material/Grid';
import { EasyFilter } from '../components/EasyFilter/EasyFilter';
import { LicensesContext } from '../contexts/LicensesContext';
import { IQuickFiltersProps } from '../components/EasyFilter/QuickFilters';
import { FilteringContextProvider } from '../contexts/FilteringContext';
import { AirgappedBtnGuard } from '../components/Licenses/AirgappedBtnGuard';

const LicensesFilter: FC = () => {
  const { t } = useTranslation();
  const { licenses } = useContext(LicensesContext);

  const quickFilters = useMemo<IQuickFiltersProps['quickFilters']>(() => {
    const filters = new Map();

    const someInvalid = (licenses || []).some((license) => license.suspended || license.expiresAt < Date.now() / 1000);

    filters.set(t('common.quickFilter.invalid'), {
      filterField: 'status',
      filterOp: 'equals',
      filterVal: 'suspended,expired',
      isVisible: someInvalid,
    });
    filters.set(t('licenses.filter.basePackages'), {
      filterField: 'isAddon',
      filterOp: 'equals',
      filterVal: 'false',
      isVisible: (licenses || []).some((license) => license.isAddon),
    });
    filters.set(t('licenses.filter.addonPackages'), {
      filterField: 'isAddon',
      filterOp: 'equals',
      filterVal: 'true',
      isVisible: (licenses || []).some((license) => license.isAddon),
    });

    return filters;
  }, [licenses]);

  return <EasyFilter quickFilters={quickFilters} />;
};

export const LicensesPage: FC = () => {
  const { t } = useTranslation();

  return (
    <div>
      <PageHeader title={t('licenses.header')} />
      <UserContextFromCurrentUserProvider>
        <FilteringContextProvider>
          <UserLicensesFetcher.WAF>
            <LicensesContextFromUserLicenses hideDiscovery={true}>
              <Grid container>
                <Grid item xs={12} md={8}>
                  <LicensesFilter />
                </Grid>
                <AirgappedBtnGuard>
                  <Grid item xs={12} md={4} display="flex" justifyContent="right" alignItems="center">
                    <RequestAirgapButton />
                  </Grid>
                </AirgappedBtnGuard>
              </Grid>

              <LicensesTable showAssignedTo={false} />
            </LicensesContextFromUserLicenses>
          </UserLicensesFetcher.WAF>
        </FilteringContextProvider>
      </UserContextFromCurrentUserProvider>
    </div>
  );
};
